jQuery(document).ready(function(a){
  a("#hinge-helpdesk-btn").on("click",function(){
    a("#hinge-result").text("");
    var e=(a("#overlay").val()),f=(a("#cup-hole").val()),g=(a("#opening-angle").val()),r=parseFloat(e)+parseFloat(f)+parseFloat(g);

    if (r >= 0 && 0.10 >= r) {
      a("#hinge-result").append('<h4 class="impact beta"><a href="mailto:sales@eurofitsystems.com?subject=Hinge%20Helpdesk%20via%20Filters&body=%5BPLEASE%20DELETE%20THIS%20TEXT%20AND%20INCLUDE%20AS%20MUCH%20INFORMATION%2FIMAGES%20REGARDING%20THE%20HINGE%20YOU%20ARE%20REQUIRING%5D">Email Us Here For More Assistance</a></h4>');   
    } else if (r >= 0.99 && 1 >= r) {
      window.location.href = "/collections/full-overlay";
    } else if (r >= 1.99 && 2 >= r) {
      window.location.href = "/collections/half-overlay"; 
    } else if (r >= 2.99 && 3 >= r) {
      window.location.href = "/collections/inset-overlay";
    } else if (r >= 9.99 && 10 >= r) {
      window.location.href = "/collections/26mm-cup-size";  
    } else if (r >= 10.99 && 11 >= r) {
      window.location.href = "/collections/hinge-helpdesk-full-overlay-26mm-cup-size";  
    } else if (r >= 11.99 && 12 >= r) {
      window.location.href = "/collections/hinge-helpdesk-half-overlay-26mm-cup-hole";  
    } else if (r >= 12.99 && 13 >= r) {
      window.location.href = "/collections/hinge-helpdesk-inset-overlay-26mm-cup-size";   
    } else if (r >= 19.99 && 20 >= r) {
      window.location.href = "/collections/35mm-cup-size";  
    } else if (r >= 20.99 && 21 >= r) {
      window.location.href = "/collections/hinge-helpdesk-full-overlay-35mm-cup-size";  
    } else if (r >= 21.99 && 22 >= r) {
      window.location.href = "/collections/hinge-helpdesk-half-overlay-35mm-cup-size";  
    } else if (r >= 22.99 && 23 >= r) {
      window.location.href = "/collections/hinge-helpdesk-inset-overlay-35mm-cup-size";  
    } else if (r >= 29.99 && 30 >= r) {
      window.location.href = "/collections/40mm-cup-size";  
    } else if (r >= 30.99 && 31 >= r) {
      window.location.href = "/collections/hinge-helpdesk-full-overlay-40mm-cup-size";   
    } else if (r >= 31.99 && 32 >= r) {
      window.location.href = "/collections/hinge-helpdesk-half-overlay-40mm-cup-size";  
    } else if (r >= 32.99 && 33 >= r) {
      window.location.href = "/collections/hinge-helpdesk-inset-overlay-40mm-cup-size";  
    } else if (r >= 99.99 && 100 >= r) {
      window.location.href = "/collections/hinge-helpdesk-hinges-under-110-degree-opening";  
    } else if (r >= 100.99 && 101 >= r) {
      window.location.href = "/collections/hinge-helpdesk-full-overlay-under-110-degrees-opening-angle";  
    } else if (r >= 101.99 && 102 >= r) {
      window.location.href = "/collections/hinge-helpdesk-half-overlay-under-110-degrees-opening-angle";   
    } else if (r >= 102.99 && 103 >= r) {
      window.location.href = "/collections/hinge-helpdesk-inset-overlay-under-110-degrees-opening-angle";   
    } else if (r >= 109.99 && 110 >= r) {
      window.location.href = "/collections/hinge-helpdesk-26mm-cup-size-under-110-degrees-opening-angle";  
    } else if (r >= 110.99 && 111 >= r) {
      window.location.href = "/collections/hinge-helpdesk-26mm-cup-size-under-110-full-overlay";  
    } else if (r >= 111.99 && 112 >= r) {
      window.location.href = "/collections/hinge-helpdesk-26mm-cup-size-under-110-half-overlay";  
    } else if (r >= 112.99 && 113 >= r) {
      window.location.href = "/collections/hinge-helpdesk-26mm-cup-size-under-110-inset";  
    } else if (r >= 119.99 && 120 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-under-110-degrees";  
    } else if (r >= 120.99 && 121 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-under-110-full-overlay";  
    } else if (r >= 121.99 && 122 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-under-110-half-overlay";  
    } else if (r >= 122.99 && 123 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-under-110-inset";  
    } else if (r >= 129.99 && 130 >= r) {
      window.location.href = "/collections/hinge-helpdesk-40mm-cup-size-under-110";  
    } else if (r >= 130.99 && 131 >= r) {
      window.location.href = "/collections/hinge-helpdesk-40mm-cup-size-under-110-full-overlay";  
    } else if (r >= 131.99 && 132 >= r) {
      window.location.href = "/collections/hinge-helpdesk-40mm-cup-size-under-110-half-overlaye";  
    } else if (r >= 132.99 && 133 >= r) {
      window.location.href = "/collections/hinge-helpdesk-40mm-cup-size-under-110-inset-overlay";  
    } else if (r >= 199.99 && 200 >= r) {
      window.location.href = "/collections/hinge-helpdesk-over-110-degrees-opening-angle";  
    } else if (r >= 200.99 && 201 >= r) {
      window.location.href = "/collections/hinge-helpdesk-full-overlay-over-110-degrees-opening-angle";      
    } else if (r >= 201.99 && 202 >= r) {
      window.location.href = "/collections/hinge-helpdesk-half-overlay-over-110-degrees-opening-angle";   
    } else if (r >= 202.99 && 203 >= r) {
      window.location.href = "/collections/hinge-helpdesk-inset-overlay-over-110-degrees-opening-angle";   
    } else if (r >= 209.99 && 210 >= r) {
      a("#hinge-result").append('<p class="impact epsilon">Unfortunately, we do not currently stock a hinge like this.</p>');
    } else if (r >= 210.99 && 211 >= r) {
      a("#hinge-result").append('<p class="impact epsilon">Unfortunately, we do not currently stock a hinge like this.</p>');
    } else if (r >= 211.99 && 212 >= r) {
      a("#hinge-result").append('<p class="impact epsilon">Unfortunately, we do not currently stock a hinge like this.</p>');
    } else if (r >= 212.99 && 213 >= r) {
      a("#hinge-result").append('<p class="impact epsilon">Unfortunately, we do not currently stock a hinge like this.</p>');
    } else if (r >= 219.99 && 220 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-over-110";      
    } else if (r >= 220.99 && 221 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-over-110-full-overlay";  
    } else if (r >= 221.99 && 222 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-over-110-half-overlay";  
    } else if (r >= 222.99 && 223 >= r) {
      window.location.href = "/collections/hinge-helpdesk-35mm-cup-size-over-110-inset-overlay";  
    
    }
  });
});
